

import {
  Box,
  Divider,
  LinearProgress,
  useMediaQuery,
  Button,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
import back from "../../../../assets/back.svg";
import projecticon from "../../../../assets/Projects/projecticon.svg";
import Progress from "../../../../assets/Projects/Progress.svg";
import document1 from "../../../../assets/document1.svg";
import document2 from "../../../../assets/Projects/document2.png";
import AddIcon from "@mui/icons-material/Add";
import StatusDropdown from "../../../../components/StatusDropdown";
import person1 from "../../../../assets/Dashboard/person1.svg";
import activity from "../../../../assets/Projects/activity.png";
import { showUnderDevelopment } from "../../../../components/alerts.js";
import { useState,useEffect } from "react";
  import AttachFileIcon from "@mui/icons-material/AttachFile";
import emptyperson from "../../../../assets/emptyperson.jpeg";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { BASE_URL } from "../../../../components/BaseUrl";
import TaskStatusDropdown from "../../../../components/TaskStatusDropdown.js";
import {toast} from "react-hot-toast";
import MapModal from "../MyTasks/MapModal.js";
import FaceScanModal from "../MyTasks/faceScanModal.js";
import EvidenceModal from "../MyTasks/ProofModal.js";
import CustomButton from "../../../../components/CustomButton.js";
const TaskDetails = ({ task, onBack }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [comments, setComments] = useState([]);

  useEffect(() => {
    if (task?.comments) {
      setComments(task.comments);
    }
  }, [task]);
  const [newComment, setNewComment] = useState("");
  const [sending, setSending] = useState(false);


    // Example: "11 Sept 2025"
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  // Example: "11 Sept 2025"
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // Example: "1:04 pm"
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} - ${formattedTime}`;
};


const [commentFile, setCommentFile] = useState(null);
const [commentFileUrl, setCommentFileUrl] = useState(null);

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!data.error && data.data?.url) {
      toast.success("Attachment uploaded");
      setCommentFile(file);
      setCommentFileUrl(data.data.url);
    } else {
      toast.error(data.message || "Upload failed");
    }
  } catch (err) {
    console.error("❌ Upload error:", err);
    toast.error("Error uploading file");
  }
};

const handleAddComment = async () => {
  if (!newComment.trim() && !commentFileUrl) return;

  setSending(true);
  try {
    const body = {
      body: newComment,
      attachments: commentFileUrl ? [commentFileUrl] : [],
    };

    const res = await fetch(
      `${BASE_URL}/task-management/worker/tasks/${task.id}/comments`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
        body: JSON.stringify(body),
      }
    );

    const data = await res.json();

    if (!data.error) {
      setComments((prev) => [...prev, data.data.comment]);
      setNewComment("");
      setCommentFile(null);
      setCommentFileUrl(null);
    } else {
      toast.error(data.message || "Failed to add comment");
    }
  } catch (err) {
    console.error("❌ Error adding comment:", err);
    toast.error("Error adding comment");
  } finally {
    setSending(false);
  }
};

  const [mapOpen, setMapOpen] = useState(false);
  const [faceOpen, setFaceOpen] = useState(false);
  const [geoData, setGeoData] = useState(null);
  const [flowType, setFlowType] = useState(null); // "start" or "complete"
const [evidenceOpen, setEvidenceOpen] = useState(false);
const [evidenceFiles, setEvidenceFiles] = useState([]);

const handleStatusChange = (status) => {
  if (status === "start") {
    setFlowType("start");
    setMapOpen(true);
  } else if (status === "completed") {
    setFlowType("complete");
    setMapOpen(true);
  }
};

  
  const handleMapContinue = (data) => {
    setGeoData(data);
    setMapOpen(false);
    setFaceOpen(true);
  };




  const handleFaceContinue = async (faceData) => {
  setFaceOpen(false);

  if (flowType === "start") {
    // existing start flow
    const body = {
      ...faceData,
      ...geoData,
      notes: "Starting task from office location",
    };

    await submitTaskStatus("start", body);
  } else if (flowType === "complete") {
    // move to evidence step
    setEvidenceOpen(true);
    setPendingFaceData(faceData); // keep face data for complete API
  }
};

const [pendingFaceData, setPendingFaceData] = useState(null);

const handleEvidenceSave = async (evidenceUrls) => {
  setEvidenceOpen(false);

  const body = {
    ...pendingFaceData,
    ...geoData,
    evidence: evidenceUrls,
    local_timestamp: new Date().toISOString(),
    notes: "Task completed successfully with all deliverables",
  };

  await submitTaskStatus("complete", body);
};

const submitTaskStatus = async (type, body) => {
  const endpoint =
    type === "start"
      ? `${BASE_URL}/task-management/worker/tasks/${task.id}/start`
      : `${BASE_URL}/task-management/worker/tasks/${task.id}/complete`;

  console.log(`📤 Sending task ${type} request:`, body);

  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (!data.error) {
      toast.success(`Task ${type}ed successfully!`);
    } else {
      toast.error(data.message || `Failed to ${type} task`);
    }
  } catch (err) {
    console.error("❌ Network error:", err);
    toast.error(`Error ${type}ing task`);
  }
};






  if (!task) {
    return (
         <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <CircularProgress size={40} /> 
    </Box>
    );
  }
  return (
    <>
    

      <Box sx={{ p: isMobile ? 1 : 0,ml:1,mr:1 }}>
        {/* Back Bar */}
         <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: 55,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
            }}
            onClick={onBack}
          >
            <img src={back} style={{ width: 30, height: 30 }} alt="back" />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "14px",
                color: "#626F86",
              }}
            >      {t("projectManagement.allTasks")} / {task.title}
            </CustomText>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 3,
            alignItems: isMobile ? "flex-start" : "stretch",
          }}
        >
          <Box
            flex={2}
            sx={{
              backgroundColor: "#fff",
              p: 2,
              borderRadius: 2,
              height: "100%",
              border: "1px solid #E4E6EF",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center",justifyContent:"space-between" ,flexWrap:"wrap", pt: 1}}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1,}}>
              <img src={projecticon} style={{ width: 25, height: 25 }} />
              <CustomText
                sx={{
                  fontSize: 16,
                  color: "#172B4D",
                  fontWeight: 500,
                  mb: 0,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
 {task.id}              </CustomText>
                  </Box>
              <Box>
                   {/* <Box sx={{ pointerEvents: "none" }}> */}


    {/* <Box sx={{ pointerEvents: "none" }}> */}

                <TaskStatusDropdown
               currentStatus={task.status} 
                //  options={["start", "completed"]}
                  options={
    task.status === "in_progress"
      ? ["completed"]   // only show completed if already started
      : ["start", "completed"] // otherwise show both
  }
                   onChange={handleStatusChange}/>
{/* /> */}
          
              {/* </Box> */}

              </Box>
          
            </Box>

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
             {task.title}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                lineHeight: 1.8,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {task.description}
            </CustomText>

           
      

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.taskDetails")}
            </CustomText>

     <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedOn")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(task.assigned_on)}         
     </CustomText>{" "}
            </Box>


  <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
              {t("projectManagement.started")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(task.start_at)}         
     </CustomText>{" "}
            </Box>

                  <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.deadline")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                {/* {task.end_at}{" "} */}
                 {formatDateTime(task.end_at)}
              </CustomText>{" "}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                  {t("projectManagement.assignedBy")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
  {task.assigned_by_name || "—"}
              </CustomText>{" "}
            </Box>


               <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.status")}
              </CustomText>
                 <Box sx={{ pointerEvents: "none" }}>

                <StatusDropdown
               currentStatus={task.status} />
               {" "}
              </Box>
            </Box>

            {task.status === "completed" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("projectManagement.productivityRating")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      textTransform: "capitalize",
                    }}
                  >
                    {task.productivity_rating || "-"}
                  </CustomText>{" "}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 2,
                    gap: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                      flexShrink: 0,
                    }}
                  >
                    {t("projectManagement.ratingNotes")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      lineHeight: 1.5,
                      maxWidth: "70%",
                    }}
                  >
                    {task.productivity_notes || "-"}
                  </CustomText>{" "}
                </Box>
              </>
            )}

             <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                  {t("projectManagement.location")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                }}
              >
                {/* {task.end_at}{" "} */}
              {task.location_address}
              </CustomText>{" "}
            </Box>

       
          


            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.documents")}
            </CustomText>
            {/* <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                alignItems: "center",
                mb: 2,
              }}
            >
              <img src={document} style={{ width: 200, height: 200 }} />
              <img src={document2} style={{ width: 200, height: 200 }} />
            </Box> */}
            <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    alignItems: "center",
    mb: 2,
  }}
>
  {task.attachments && task.attachments.length > 0 ? (
    task.attachments.map((fileUrl, idx) => {
      const fileName = fileUrl.split("/").pop(); // get file name
      const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

      return (
        <Box
          key={idx}
          sx={{
            width: 200,
            height: 200,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
            background: "#F9FAFB",
          }}
        >
          {isPdf ? (
            <img
              src={document1} // use your existing "document.png" icon for PDFs
              alt="pdf"
              style={{ width: 60, height: 60, marginBottom: 8 }}
            />
          ) : (
            <img
              src={document1}
              alt={fileName}
              style={{
                width: "70px",
                height: "70px",
                objectFit: "cover",
                borderRadius: 4,
                marginBottom: 8,
              }}
            />
          )}
          <Typography
            sx={{
              fontSize: 12,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
            title={fileName} // tooltip for full name
          >
            {fileName}
          </Typography>
            <Box sx={{ textAlign: "center" ,mt:1.5}}>
              <CustomButton
            label={t("viewDocument")} 
                size="small"
                variant="contained"
          
                onClick={() => window.open(fileUrl, "_blank")}
             />
             </Box>
          
        </Box>
      );
    })
  ) : (
    <Typography
      sx={{ fontSize: 14, color: "#5E5C5C", fontFamily: "Poppins, sans-serif" }}
    >
      No attachments
    </Typography>
  )}
</Box>


          </Box>

    
        </Box>
      </Box>
      <Box>
{/* Add Comment */}
<Box sx={{ p: 2, background: "#fff", mt: 2, border: "1px solid #091E4224", borderRadius: 1 }}>
  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 18,
      fontWeight: 600,
      color: "#000",
      textAlign: "left",
    }}
  >
    {t("projectManagement.addComment")}
  </CustomText>

  

<Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "center" }}>
  {/* Attachment icon */}
  <label htmlFor="comment-attachment">
    <AttachFileIcon
      sx={{ cursor: "pointer", color: "#006EC2" }}
    />
  </label>
  <input
    id="comment-attachment"
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleFileChange}
  />

  {/* Comment input */}
  <input
    className="project_input"
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
    placeholder={t("projectManagement.writeComment")}
    style={{ flex: 1, height: 40 }}
    disabled={sending}
  />

  {/* Add button */}
  <Button
    variant="contained"
    onClick={handleAddComment}
    disabled={sending}
    sx={{
      px: 2,
      backgroundColor: "#006EC2",
      color: "#fff",
      textTransform: "none",
      fontSize: 14,
      borderRadius: 1,
      height: 36,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {sending ? t("projectManagement.add") : t("projectManagement.add")}
  </Button>
</Box>

  {/* Comments list */}
 <Box sx={{ mt: 2, borderRadius: 2 }}>
  {comments.length === 0 ? (
    <CustomText sx={{ ...textStyles.h1, fontSize: 14, color: "#5E5C5C" }}>
 {t("projectManagement.noComments")}
    </CustomText>
  ) : (
    comments.map((c) => (
      <Box key={c.id} sx={{ p: 2, borderBottom: "1px solid #EEF2F7" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.6 }}>
            {/* <Avatar
                crossOrigin="anonymous"

              // alt={c.author_name}
                src={c.attachments && c.attachments.length > 0 ? c.attachments[0] : ""}

         
              sx={{ width: 40, height: 40, borderRadius: "50%" }}
            /> */}
                {c.attachments && c.attachments.length > 0 && (
      <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
        {c.attachments.map((fileUrl, idx) => (
          <img
          crossOrigin="anonymous"
            key={idx}
            src={fileUrl || emptyperson}
            alt={`attachment-${idx}`}
            style={{
              width: 60,
              height: 60,
              objectFit: "contain",
              borderRadius: "30px",
              border: "1px solid #ddd",
            }}
          />
        ))}
      </Box>
    )}
            <Box>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: "#100F0F" }}
              >
                {c.author_name || "-"}
              </CustomText>

              <CustomText
            sx={{ fontSize: 15, fontWeight: 400, color: "#5E5C5C", lineHeight: 1.5 }}
          >
            {(i18n.language?.split("-")[0] === "es" ? c.body_es : c.body_en) || c.body}
          </CustomText>
            
            </Box>
          </Box>

          {/* ✅ Comment badge */}
          <Box sx={{display:"flex",flexWrap:"wrap", alignItems:"center",gap:1,}}>
          <Box
            sx={{
              px: 2,
              py: 0.4,
              borderRadius: "4px",
              backgroundColor: "#E4E6EB",
              fontSize: 12,
              fontWeight: 500,
              color: "#003149",
              display: "inline-block",
                 fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            Comment
          </Box>
            <CustomText
                sx={{ ...textStyles.h1, fontSize: 13, color: "#5E5C5C", fontWeight: 400,
                     fontFamily: 'Nunito Sans, sans-serif',
                 }}
              >
                {formatDateTime(c.created_at)}
              </CustomText>
              </Box>
        </Box>

       
      </Box>
    ))
  )}
</Box>
</Box>

      <MapModal
  open={mapOpen}
  onClose={() => setMapOpen(false)}
  onContinue={handleMapContinue}
  taskLocation={{
    lat: task?.location_lat ? parseFloat(task.location_lat) : null,
    lng: task?.location_lng ? parseFloat(task.location_lng) : null,
    radius_m: task?.location_radius_m ? Number(task.location_radius_m) : 100,
  }}
/>
<FaceScanModal
  open={faceOpen}
  onClose={() => setFaceOpen(false)}
  onContinue={handleFaceContinue}
/>
<EvidenceModal
  open={evidenceOpen}
  onClose={() => setEvidenceOpen(false)}
  onSave={handleEvidenceSave}
/>
      </Box>
    </>
  );
};
export default TaskDetails




